import { css } from "@emotion/react";
import { AssignedUserTable } from "@podtrac/common/accounts";
import React from "react";
import { Helmet } from "react-helmet";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { useAccount, useAccountID } from "../../store/account";

export default function Users() {
    const dispatch = useDispatch();
    const accountID = useAccountID();
    const navigate = useNavigate();

    const { data: account = {} } = useAccount();

    return (
        <>
            <Helmet>
                <title>Users - Podtrac</title>
            </Helmet>
            <h1>Users</h1>

            <AssignedUserTable />

            {account && account.offerUpgrade ? (
                <div
                    css={css`
                        margin: 1rem 0;
                        padding: 0 1rem;
                        background: #ffe18d;
                        border: 2px solid #ffc82d;
                        & > p {
                            margin: 1rem 0;
                        }
                    `}
                >
                    <p>
                        Your free plan includes one user, to add users{" "}
                        <Link to={`/dashboard/${accountID}/upgrade`}>
                            upgrade to our <b>Grow Your Show</b> plan
                        </Link>
                        .
                    </p>
                </div>
            ) : null}
        </>
    );
}
